export function validateEmail (email) {
  const EMAIL_REGEXP = new RegExp(
    '^[a-z0-9]+([._a-z0-9]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,15})$',
    'i'
  )
  // Vérifiez d'abord si l'email correspond à la regex
  if (!EMAIL_REGEXP.test(email)) {
    return false
  }
  // Vérifiez la longueur de la TLD
  return email.substring(email.lastIndexOf('.') + 1).length <= 15
}
